import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Services from '../../api/Services';
import ServiceSidebar from './sidebar'
import Contact from './contact';
// import { Link } from 'react-router-dom'
import simg1 from '../../images/service-single/2.jpg'
import simg2 from '../../images/service-single/3.jpg'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/Logo.png'

const ServiceSinglePage = (props) => {
    const { slug } = useParams()

    const serviceDetails = Services.find(item => item.slug === slug)

    return (
        <Fragment>
            <Navbar Logo={Logo.png} />
            <PageTitle pageTitle={serviceDetails.title} pagesub={'Service Single'} />
            <div className="wpo-service-single-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12">
                            <div className="wpo-service-single-wrap">
                                <div className="wpo-service-single-item">
                                    
                                    <div className="wpo-service-single-title">
                                        <h2>{serviceDetails.title}</h2>
                                    </div>
                                    <p><b>Beautiful Homes Start with Thoughtful Design</b></p>
                                    <p>Looking to build your dream home interior in Bengaluru? YATRI INTERIORS brings you personalized and fully 
                                    functional home interior solutions that combine comfort, aesthetics, and smart utility.</p>
                                    
                                   
                                </div>
                                <div className="wpo-service-single-item list-widget">
                                    <div className="wpo-service-single-title">
                                        <h3>We specialize in:</h3>
                                    </div>
                                   
                                    <ul>
                                        <li>Modular kitchen design and installation</li>
                                        <li>Wardrobes, TV units, and storage solutions</li>
                                        <li>Bedroom, living room, and dining area design</li>
                                        <li>False ceiling and lighting layout</li>
                                        <li>Color-coordinated painting and finish work</li>
                                    </ul>
                                    <p>Transform your home into a sanctuary of style and comfort with our expert design & execution team.</p>
                                </div>
                               <div className="wpo-service-single-main-img">
                                        <img src={serviceDetails.sSImg} alt="eimg" />
                                    </div>
                               {/**** <div className="row mt-4">
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg1} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg2} alt="" />
                                            </div>
                                        </div>
                                    </div> */}
                                <br/>
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-contact-area">
                                        <div className="wpo-contact-title">
                                            <h2>Have project in mind? Let's discuss</h2>
                                            <p>Get in touch with us to see how we can help you with your project</p>
                                        </div>
                                        <div className="wpo-contact-form-area">
                                            <Contact />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ServiceSidebar />
                    </div>
                </div>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;



